module.exports = __webpack_public_path__ + "static/media/documentsCarousel.0c1aab77.jpg";